import { createSelector } from '@reduxjs/toolkit';

import type { PostType } from '@/components/TopMenu';
import type { AuthAllType } from '@/containers/const';
import type { PageType } from '@/domain/ui/redux';
import type { RootState } from '@/store';
import type { CategoryType, IconNames } from '@/types/common/icon';

import { imageFolderPath } from '@/constants/env';
import { AUTH_ALL_ONLY_TYPE, authAllInfomation } from '@/containers/const';

const getAuthList = (
  isExistChild: boolean,
  isExistFacility: boolean,
  isExistHomepage: boolean,
) => {
  const items: {
    [key in AuthAllType]?: {
      name: string,
      description: string,
      icon: IconNames,
      image: string,
      category: CategoryType,
      order: number,
    }
  } = {};
  let order = 0;
  for (let i = 0; i < AUTH_ALL_ONLY_TYPE.length; i += 1) {
    const item = authAllInfomation[AUTH_ALL_ONLY_TYPE[i]];
    let isAdd = true;
    if (item.isChildNecessary && !isExistChild) {
      isAdd = false;
    }
    if (item.isFacilityNecessary && !isExistFacility) {
      isAdd = false;
    }
    if (item.isHomepageNecessary && !isExistHomepage) {
      isAdd = false;
    }
    if (isAdd) {
      items[AUTH_ALL_ONLY_TYPE[i]] = {
        ...authAllInfomation[AUTH_ALL_ONLY_TYPE[i]],
        order,
      };
      order += 1;
    }
  }
  return items as {
    [key in AuthAllType]: {
      name: string,
      description: string,
      icon: IconNames,
      image: string,
      category: CategoryType,
      order: number,
    }
  };
};

export const modeSelector = createSelector(
  (state: RootState) => state.user,
  (user) => user.mode,
);

export const userSelector = createSelector(
  (state: RootState) => state.user,
  (user) => user.user,
);

export const selectedNurseryIdSelector = createSelector(
  (state: RootState) => state.payment.selectedNurseryId,
  (selectedNurseryId) => selectedNurseryId,
);

export const postsSelector = createSelector(
  [
    (state: RootState) => state.child,
    (state: RootState) => state.user.user,
    (state: RootState) => state.childApply.facilityList,
    (state: RootState) => state.childApply.facilityHomepageSettingsList,
  ],
  (child, user, facilityList, facilityHomepageSettingsList) => {
    const facility = facilityList.find(
      (v) => `${v.data.parentId}_${v.data.childId}` === `${user?.name}_${child.childId}`,
    );
    const homepageUrl = facilityHomepageSettingsList.find(
      (v) => v.nurseryId === facility?.data.facilityId,
    )?.url;
    const isExistHomepage = homepageUrl !== undefined && homepageUrl !== '';
    const contentList = getAuthList(child !== null, facility !== undefined, isExistHomepage);
    const keys = Object.keys(contentList);
    const posts: PostType[] = keys.map((key) => {
      const cont = contentList[key as AuthAllType];
      return {
        image: `${imageFolderPath}${cont.image}`,
        title: cont.name,
        key: key as PageType,
        category: cont.category,
        icon: cont.icon,
        order: cont.order,
      };
    });
    return posts.sort((a, b) => a.order - b.order);
  },
);
